import React from 'react';
interface IAuditRow {
    activity: any;
}

const AuditLogRow: React.FC<IAuditRow> = ({ activity }) => {
  const formatTimestamp = (isoTimestamp: string): string => {
    if (isoTimestamp === undefined) {
      return '';
    }
    const date = new Date(isoTimestamp);

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric', // Corrected to specific string literal
      month: 'short', // Corrected to specific string literal
      day: '2-digit', // Corrected to specific string literal
      hour: 'numeric', // Corrected to specific string literal
      minute: '2-digit', // Corrected to specific string literal
      hour12: true, // 12-hour format
      timeZoneName: 'short', // Include timezone abbreviation (e.g., EST)
    };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  };


  return (
    <>
      <div className='audit-doc-tabe-row'>
        <div className='audit-doc-tabe-row'>
          <div className='audit-doc-tabe-row-frame'>
            <div className='audit-doc-tabe-row-frame-right'>
              <div>
                <div className='audit-doc-tabe-row-frame-right-text'>{activity.user.firstName} {activity.user.lastName}</div>
              </div>
            </div>
            <div className='audit-doc-tabe-row-frame-right'>
              <div>
                <div className='audit-doc-tabe-row-frame-right-text'>{activity.action}</div>
              </div>
            </div>
            <div className='audit-doc-tabe-row-frame-right'>
              <div>
                <div className='audit-doc-tabe-row-frame-right-text'>{formatTimestamp(activity.timeStamp)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuditLogRow;
